// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.k7l_dr{position:absolute;z-index:50;top:0;right:0;bottom:0;left:0;display:flex;flex-direction:column;width:100%;height:100%;background-color:black;justify-content:center;align-items:center}.k7l_dr.oENMyY video,.k7l_dr.WjkYKg video{width:100%;height:100%}.k7l_dr.ESt0C0 video{position:absolute}.k7l_dr.zRo3JY.ESt0C0 video{width:100%;height:auto !important}.k7l_dr.LdRApz.ESt0C0 video{height:100%}.k7l_dr video{position:relative;z-index:1;box-shadow:0 0 20px rgba(0,0,0,0.2)}.k7l_dr.dAHSaP{cursor:none}.K28LcQ{position:absolute;z-index:0;top:0;right:0;bottom:0;left:0;filter:blur(14px)}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen": `k7l_dr`,
	"regularMode": `oENMyY`,
	"blurMode": `WjkYKg`,
	"fillMode": `ESt0C0`,
	"verticalStripes": `zRo3JY`,
	"horizontalStripes": `LdRApz`,
	"hiddenCursor": `dAHSaP`,
	"backgroundCanvas": `K28LcQ`
};
export default ___CSS_LOADER_EXPORT___;
